import React, { useCallback, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'shared/lib';

import { isLoggedSelector } from 'entities/user';

import { useSendLoansContactData } from 'features/SendLoansContactData';
import { useSendFirstTouch } from 'features/SendLoansFirstTouch';

import { validateUserDataThunk } from '../../lib';
import { updateUserLandingDataThunk, Form } from '../LandingInfo';

export type TAnketaProps = {
  isLoading?: boolean;
  onFormComplete?: (isValid: boolean) => void;
};

export const VitrinsAnketa: FC<TAnketaProps> = (props) => {
  const { isLoading, onFormComplete } = props;
  const dispatch = useAppDispatch();
  const sendContact = useSendLoansContactData();
  const isAuth = useAppSelector(isLoggedSelector);
  const [isValidating, setIsValidating] = useState(false);
  const sendFirstTouch = useSendFirstTouch();

  const onFormSubmit = useCallback(
    async (_: unknown) => {
      setIsValidating(true);
      await dispatch(updateUserLandingDataThunk());
      if (isAuth) {
        sendContact();
      }
      dispatch(
        validateUserDataThunk({
          onComplete: () => setIsValidating(false),
          onSuccess: () => onFormComplete?.(true),
          onError: () => onFormComplete?.(false),
        }),
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isAuth],
  );

  return (
    <Form
      onFormSubmit={onFormSubmit}
      isLoading={isLoading || isValidating}
      onAuthorizationSuccess={sendFirstTouch}
    />
  );
};
